package utils

import de.geomobile.common.time.LocalDate
import de.geomobile.common.time.LocalDateTime


fun Long.millisToLocalDateTime() = LocalDateTime(this)
fun Long.millisToLocalDate() = LocalDate(this)
